import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../_shared/message-dialog/message-dialog.component';
import { ErrorDialogConfig } from '../../_config/error-dialog-config';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  dialogRef?: MatDialogRef<MessageDialogComponent>;
  constructor(private dialog: MatDialog, private auth: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        //let errorMessage = err.message || err.statusText;
        if (err.status === 401) {
          this.auth.logout();
        }
        if (!this.dialogRef && request.responseType !== 'text') {
          let message = err.headers.get('Error');
          if (err.status === 401) {
            message = 'Sessione scaduta';
          }
          if (err.status === 400) {
            message = err?.error?.errorMessages
              ? 'Si sono verificati i seguenti errori: ' +
                err?.error?.errorMessages?.join(', ')
              : 'Errore generico';
          }
          this.dialogRef = this.dialog.open(
            MessageDialogComponent,
            new ErrorDialogConfig(message || undefined)
          );

          this.dialogRef
            .afterClosed()
            .subscribe((_) => (this.dialogRef = undefined));
        }
        return throwError(() => err);
      })
    );
  }
}
